import { Box, Stack } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { NavBar } from '../appBars/navBar/navBar';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PrizeIcon from '../../logo/prize.png';
import DealIcon from '../../logo/deal.png';
import { AccountItem } from '../account/accountItem';
import HelpIcon from '@mui/icons-material/Help';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { useTranslation } from 'react-i18next';
import { appStyleMode } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { useRouteNavigator } from '../../routes/useRouteNavigator';

export function Info() {
  const routeNavigator = useRouteNavigator();

  const { t } = useTranslation();

  return (
    <Box>
      <NavBar barTitle={t('info:information')} />
      <Box>
        <Box className={appStyleMode === AppStyle.Mobile && 'info-items-list'}>
          <Stack direction="column" justifyContent="center" alignItems="center">
            <AccountItem
              icon={<AddCircleOutlineIcon />}
              title={t('info:allServices')}
              open={() => routeNavigator.goToSearch()}
            />
            <AccountItem
              icon={<LocationOnIcon />}
              title={t('salesPoint:salesPoints')}
              open={() => routeNavigator.goToSalesPoints()}
            />
            <AccountItem
              icon={<img height={25} src={PrizeIcon} alt="Prize" />}
              title={t('achievement:achievements')}
              open={() => routeNavigator.goToAchievements()}
            />
            <AccountItem
              icon={<img height={25} src={DealIcon} alt="Deal" />}
              title={t('info:partners')}
              open={() => routeNavigator.goToPartners()}
            />
            <AccountItem icon={<AssignmentIcon />} title={t('info:rules')} open={() => routeNavigator.goToRules()} />
            <AccountItem
              icon={<AssignmentIcon />}
              title={t('info:privacyPolicy')}
              open={() => routeNavigator.goToPrivacyPolicy()}
            />
            <AccountItem icon={<LiveHelpIcon />} title={t('faq:menuTitle')} open={() => routeNavigator.goToFaq()} />
            <AccountItem icon={<HelpIcon />} title={t('info:contactUs')} open={() => routeNavigator.goToSupport()} />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
